import { css } from '@emotion/css';
import cls from 'classnames';
import { FC, useState } from 'react';

import { ArrowRightCircledFilledIcon } from '@/components/icons/arrow-icon';

interface CollapsableProps {
  title: string;
  isCollapsed: boolean;
  onClick: () => void;
}

const transitionMaxHeight = css`
  transition: max-height 0.3s ease-in-out;
`;

// NOTE: Code taken from faq-item/index.tsx but made into more generic component
const Collapsable: FC<CollapsableProps> = ({
  title,
  isCollapsed,
  onClick,
  children,
}) => {
  const [maxHeight, setMaxHeight] = useState<number>(0);

  const ref = (node: HTMLDivElement) => {
    if (node) {
      setMaxHeight(isCollapsed ? 0 : node.getBoundingClientRect().height);
    }
  };

  return (
    <div
      className={cls(
        'pb-4 md:pb-5 mb-4 last:mb-0 transition-colors duration-300 rounded-2',
        isCollapsed
          ? ' teair:bg-air-lightBlue teair:bg-opacity-50 cursor-pointer tesn:bg-esn-secondary-dark'
          : ' tesn:bg-esn-secondary teair:bg-air-lightBlue',
      )}
      onClick={() => isCollapsed && onClick()}
    >
      {/* Tricky css way to add an offset for anchor scrolling */}
      <div className="relative -top-16 md:-top-24" />

      <div
        className="flex justify-between items-center pt-4 px-4 md:pt-5 md:px-6 cursor-pointer"
        onClick={() => !isCollapsed && onClick()}
      >
        <h3 className="text-body1 font-semibold mr-4 teair:text-air-skyBlue teair:text-opacity-60">
          {title}
        </h3>

        <ArrowRightCircledFilledIcon
          className={cls(
            'transform transition-transform duration-300 flex-shrink-0',
            isCollapsed ? 'rotate-90' : '-rotate-90',
          )}
          backgroundClassName={cls(
            'transition-colors duration-300 fill-red-medium tesn:fill-esn-primary teair:fill-air-lemon',
            isCollapsed
              ? 'tesn:fill-esn-secondary'
              : 'tesn:fill-esn-secondary-dark',
          )}
          arrowClassName={'teair:fill-air-mediumBlue'}
        />
      </div>

      <div
        className={cls('overflow-hidden', transitionMaxHeight)}
        style={{ maxHeight: `${maxHeight}px` }}
      >
        <div ref={ref} className="pt-2">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Collapsable;
